module.exports = __webpack_public_path__ + "img/icon-friends.ccb12f13.svg";